// core version + certain modules modules:
import SwiperCore, {Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, A11y} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, A11y]);

const srA11y = window.srA11y || {};

const a11yConfig = (prevSlideMessage, nextSlideMessage, extra = {}) => ({
    enabled: true,
    prevSlideMessage,
    nextSlideMessage,
    containerRoleDescriptionMessage: srA11y.carousel || 'carrousel',
    itemRoleDescriptionMessage: srA11y.slide || 'slide',
    ...extra,
});

if ($('.logo-slider').length > 0) {

    let logoSlider = new SwiperCore('.logo-slider ', {
        spaceBetween: 40,
        loop: true,
        slidesPerView: 2,
        direction: 'horizontal',
        autoplay: {
            delay: 0,
        },
        speed: 3000,
        loopAdditionalSlides: 1,
        a11y: false,
        breakpoints: {
            560: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 48,
            }
        }
    });
}

if ($('.team-slider').length > 0) {

    let teamSlider = new SwiperCore('.team-slider ', {
        spaceBetween: 16,
        slidesPerView: 1.1,
        direction: 'horizontal',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        a11y: a11yConfig(
            srA11y.teamPrev || 'Vorige teamlid',
            srA11y.teamNext || 'Volgende teamlid',
            { paginationBulletMessage: srA11y.paginationBullet || 'Ga naar slide {{index}}' }
        ),
        breakpoints: {
            560: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 40,
            }
        }
    });

    // Swiper returns an array when the page has more than one team block.
    [].concat(teamSlider).forEach(slideToFocusedSlide);
}

// Keyboard users: bring an off-screen slide into view when a link inside it gets focus.
// (The section uses overflow: clip, so the browser can't scroll it sideways on focus.)
function slideToFocusedSlide(slider) {
    slider.el.addEventListener('focusin', (event) => {
        const index = Array.prototype.indexOf.call(slider.slides, event.target.closest('.swiper-slide'));
        const perView = Math.floor(slider.params.slidesPerView) || 1;
        if (index !== -1 && (index < slider.activeIndex || index >= slider.activeIndex + perView)) {
            slider.slideTo(index);
        }
    });
}

if ($('.reviews-slider').length > 0) {

    new SwiperCore('.reviews-slider ', {
        spaceBetween: 120,
        loop: true,
        slidesPerView: 1,
        direction: 'horizontal',
        loopAdditionalSlides: 1,
        effect: 'fade',
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-buttons__button--next',
            prevEl: '.swiper-buttons__button--prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            dynamicBullets: true,
        },
        a11y: a11yConfig(
            srA11y.reviewPrev || 'Vorige review',
            srA11y.reviewNext || 'Volgende review'
        ),
        breakpoints: {

            768: {
                pagination: false,
            }
        }
    });
}
